module.exports = "/static/assets/3724156c798fb9f1230c9bd1c877f1fd.png";